import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/services/api'

export const useGameStore = defineStore('game', () => {
    const gameId = ref(null)
    const playerId = ref(null)
    const gameState = ref(null)
    const error = ref(null)
    const loading = ref(false)

    const createGame = async (playerName) => {
        loading.value = true
        try {
            const response = await api.createGame(playerName)
            gameId.value = response.data.gameId
            playerId.value = response.data.playerId
            error.value = null
        } catch (err) {
            error.value = err.response?.data?.message || 'Failed to create game'
        } finally {
            loading.value = false
        }
    }

    const joinGame = async (gameIdToJoin, playerName) => {
        loading.value = true
        try {
            const response = await api.joinGame(gameIdToJoin, playerName)
            gameId.value = gameIdToJoin
            playerId.value = response.data.playerId
            error.value = null
        } catch (err) {
            error.value = err.response?.data?.message || 'Failed to join game'
        } finally {
            loading.value = false
        }
    }

    const fetchGameState = async () => {
        if (!gameId.value) return
        
        loading.value = true
        try {
            const response = await api.getGameState(gameId.value)
            gameState.value = response.data
            error.value = null
        } catch (err) {
            error.value = err.response?.data?.message || 'Failed to fetch game state'
        } finally {
            loading.value = false
        }
    }

    const makeGuess = async (guesserId, targetId, position, number, color) => {
        loading.value = true
        try {
          const response = await api.makeGuess(
            gameId.value,
            guesserId,
            targetId,
            position,
            number,
            color
          )
          await fetchGameState()
          return response.data.correct
        } catch (err) {
          error.value = err.response?.data?.message || 'Failed to make guess'
          return false
        } finally {
          loading.value = false
        }
      }
      const drawCard = async (gameId) => {
        const response = await api.drawCard(gameId)
        return response.data.card
      }
      const insertCard = async (gameId, playerId, card, position) => {
        await api.insertCard(gameId, playerId, card, position)
        await fetchGameState()
      }

    const resetGame = () => {
        gameId.value = null
        playerId.value = null
        gameState.value = null
        error.value = null
    }

    return {
        gameId,
        playerId,
        gameState,
        error,
        loading,
        createGame,
        joinGame,
        fetchGameState,
        makeGuess,
        resetGame,
        drawCard,
    insertCard
    }
})